var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 15.0003V4.16699",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8333C11.779 10.6226 11.1457 10.1839 10.695 9.58292C10.2443 8.98198 10.0005 8.25117 10 7.5C9.99955 8.25117 9.7557 8.98198 9.305 9.58292C8.8543 10.1839 8.221 10.6226 7.5 10.8333",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.665 5.4171C14.8568 5.08501 14.9695 4.71325 14.9946 4.3306C15.0197 3.94794 14.9565 3.56464 14.8097 3.21035C14.663 2.85605 14.4367 2.54027 14.1484 2.28742C13.8601 2.03457 13.5175 1.85143 13.1471 1.75218C12.7766 1.65293 12.3884 1.64022 12.0123 1.71503C11.6361 1.78985 11.2823 1.95019 10.9781 2.18364C10.6738 2.41709 10.4274 2.71741 10.2578 3.06134C10.0882 3.40528 9.99998 3.78362 10 4.1671C10 3.78362 9.91181 3.40528 9.74222 3.06134C9.57262 2.71741 9.32617 2.41709 9.02194 2.18364C8.71771 1.95019 8.36386 1.78985 7.98775 1.71503C7.61164 1.64022 7.22336 1.65293 6.85294 1.75218C6.48253 1.85143 6.13992 2.03457 5.85161 2.28742C5.5633 2.54027 5.33702 2.85605 5.19028 3.21035C5.04353 3.56464 4.98026 3.94794 5.00536 4.3306C5.03046 4.71325 5.14324 5.08501 5.335 5.4171",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9971 4.27051C15.4869 4.39646 15.9417 4.63222 16.3269 4.95993C16.7121 5.28765 17.0177 5.69874 17.2205 6.16205C17.4234 6.62536 17.5181 7.12875 17.4976 7.6341C17.4771 8.13945 17.3418 8.6335 17.1021 9.07884",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15.0003C15.7338 15.0002 16.447 14.7581 17.0291 14.3114C17.6112 13.8647 18.0297 13.2384 18.2196 12.5297C18.4095 11.8209 18.3603 11.0693 18.0795 10.3914C17.7987 9.7135 17.3021 9.14718 16.6667 8.78027",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6388 14.5693C16.6972 15.0212 16.6624 15.4802 16.5364 15.9181C16.4105 16.356 16.1961 16.7634 15.9065 17.1151C15.6169 17.4669 15.2583 17.7556 14.8528 17.9633C14.4473 18.171 14.0035 18.2934 13.5489 18.3229C13.0942 18.3525 12.6383 18.2884 12.2094 18.1348C11.7804 17.9813 11.3875 17.7414 11.0549 17.43C10.7223 17.1186 10.457 16.7423 10.2755 16.3244C10.094 15.9065 10.0002 15.4558 9.99967 15.0002C9.99919 15.4558 9.9053 15.9065 9.72381 16.3244C9.54232 16.7423 9.27708 17.1186 8.94447 17.43C8.61186 17.7414 8.21895 17.9813 7.79 18.1348C7.36104 18.2884 6.90515 18.3525 6.45049 18.3229C5.99582 18.2934 5.55203 18.171 5.14652 17.9633C4.74101 17.7556 4.3824 17.4669 4.09283 17.1151C3.80325 16.7634 3.58887 16.356 3.46291 15.9181C3.33696 15.4802 3.3021 15.0212 3.36051 14.5693",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00018 15.0003C4.26643 15.0002 3.55319 14.7581 2.97107 14.3114C2.38895 13.8647 1.97049 13.2384 1.78058 12.5297C1.59067 11.8209 1.63992 11.0693 1.92069 10.3914C2.20147 9.7135 2.69808 9.14718 3.33351 8.78027",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00325 4.27051C4.51342 4.39646 4.05867 4.63222 3.67345 4.95993C3.28822 5.28765 2.98262 5.69874 2.77979 6.16205C2.57696 6.62536 2.48222 7.12875 2.50275 7.6341C2.52327 8.13945 2.65852 8.6335 2.89826 9.07884",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveKnowledge);
export default __webpack_public_path__ + "static/media/ic_active_knowledge.27147228e957999ef0af29365283df8c.svg";
export { ForwardRef as ReactComponent };